import { render, staticRenderFns } from "./PipelineEvent.vue?vue&type=template&id=506d0848&"
import script from "./PipelineEvent.vue?vue&type=script&lang=js&"
export * from "./PipelineEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports